module.exports = __webpack_public_path__ + "img/eye.e072d461.svg";